import { baseUrl, notify } from "./index";
import {
  getToken,
  getUser,
  cacheResponse,
  retreiveCachedResponse
} from "./storage";

export const machineStatuses = ["Available", "Issue", "Missing", "On Hire"];

export const inspectionPriority = ["None", "Low", "Medium", "High"];

export const inspectionPrioritySelect = inspectionPriority.map(priority => ({
  label: priority,
  value: priority
}));

export const machineStatusesSelect = machineStatuses.map(status => ({
  label: status,
  value: status
}));

export async function searchMachines(machine_code) {
  let token = await getToken();
  let response = await (await fetch(`${baseUrl}/search/machines`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json"
    },
    body: JSON.stringify({
      machine_code
    })
  })).json();
  // Convert to format react-select wants
  let mappedResponse = response.data.data.map(({ id, code }) => ({
    value: id,
    label: code
  }));
  return mappedResponse;
}
export async function searchWHMachines(machine_code) {
  let token = await getToken();
  let response = await (await fetch(`${baseUrl}/search/wh_machines`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json"
    },
    body: JSON.stringify({
      machine_code
    })
  })).json();
  // Convert to format react-select wants
  let mappedResponse = response.data.map(({ id, code }) => ({
    value: id,
    label: code
  }));
  return mappedResponse;
}

export async function searchTool(tool_code) {
  let token = await getToken();
  let response = await (await fetch(`${baseUrl}/search/tools`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json"
    },
    body: JSON.stringify({
      tool_code
    })
  })).json();
  // Convert to format react-select wants
  let mappedResponse = response.data.data.map(({ id, code }) => ({
    value: id,
    label: code
  }));
  return mappedResponse;
}

export async function searchWHTool(tool_code) {
  let token = await getToken();
  let response = await (await fetch(`${baseUrl}/search/wh_tools`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json"
    },
    body: JSON.stringify({
      tool_code
    })
  })).json();
  // Convert to format react-select wants
  let mappedResponse = response.data.map(({ id, code }) => ({
    value: id,
    label: code
  }));
  return mappedResponse;
}

export async function getFormsForMachine(machine_id) {
  let token = await getToken();
  let history = [];

  try {
    let response = await (await fetch(
      `${baseUrl}/machines/inspection_history/${machine_id}`,
      {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
    )).json();
    
    history = response.data.inspections;
    
    cacheResponse(`getFormsForMachine:${machine_id}`, history);
  } catch (error) {
    history = await retreiveCachedResponse(`getFormsForMachine:${machine_id}`);
  }
  return history;
}

export async function getFormsForTool(tool_id) {
  let token = await getToken();
  let history = [];

  try {
    let response = await (await fetch(
      `${baseUrl}/tools/inspection_history/${tool_id}`,
      {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
    )).json();
    
    history = response.data.inspections;
    cacheResponse(`getFormsForTool:${tool_id}`, history);
  } catch (error) {
    history = await retreiveCachedResponse(`getFormsForTool:${tool_id}`);
  }
  return history;
}

export async function getStoreMachines(store_id, av=null) {
  let token = await getToken();
  let machines = [];
  try {
    let response = await (await fetch(`${baseUrl}/av_machines`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify({ store_id })
    })).json();

    machines = response.data;
    if (av !== null){
      machines = [];
      response.data.map((m)=>{
        if (m.machine_status !== ('In Transit' || 'On Hire' || 'Overdue') ){
          machines.push(m);
        }
      })
    }
    cacheResponse(`getStoreMachines:${store_id}`, machines);
  } catch (error) {
    console.error(error);
    machines = await retreiveCachedResponse(`getStoreMachines:${store_id}`);
  }

  return machines;
}

export async function getStoreTools(store_id, av=null) {
  let token = await getToken();
  let tools = [];
  try {
    let response = await (await fetch(`${baseUrl}/av_tools`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify({ store_id })
    })).json();

    tools = response.data;
    if (av !== null){
      tools = [];
      response.data.map((t)=>{
        if (t.tool_status !== ('In Transit' || 'On Hire' || 'Overdue') ){
          tools.push(t);
        }
      })
    }

    cacheResponse(`getStoreTools:${store_id}`, tools);
  } catch (error) {
    console.error(error);
    tools = await retreiveCachedResponse(`getStoreTools:${store_id}`);
  }

  return tools;
}


export async function getFaultyList(store_id) {
  let token = await getToken();
  let tools = [];
  try {
    let response = await (await fetch(`${baseUrl}/faulty_lists`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify({ store_id })
    })).json();

    tools = response.data;
    cacheResponse(`getFaultyList:${store_id}`, tools);
  } catch (error) {
    console.error(error);
    tools = await retreiveCachedResponse(`getFaultyList:${store_id}`);
  }

  return tools;
}

export async function getConditionList() {
  let token = await getToken();
  let condition_lists = [];
  try {
    let response = await (await fetch(`${baseUrl}/condition_lists`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`
      },
      // body: JSON.stringify({ store_id })
    })).json();

    condition_lists = response.data;
    cacheResponse(condition_lists);
  } catch (error) {
    console.error(error);
    condition_lists = await retreiveCachedResponse(`getConditionList`);
  }

  return condition_lists;
}

export async function getCheckUserType(store_id=null) {
  let token = await getToken();
  let check = [];
  let result = false;
  try {
    let response = await (await fetch(`${baseUrl}/check_user_type`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify({ store_id })
    })).json();
    result = (store_id !== null && response.data.type_id === 4 && response.data.store_group_id !== 3 ) ? false : true;
    // 스토어아이디 없이 보냈을 땐 user type id (3,4 )리턴, 스토어아이디 있을 때는 타입 체크 까지 해서 true/false 반환 
    check = store_id == null ? response.data.type_id : result; 
    cacheResponse(check);
  } catch (error) {
    console.error(error);
    check = await retreiveCachedResponse(`getCheckUserType:`);
  }

  return check;
}

export async function getFormForMachine(formId) {
  let token = await getToken();
  let form = {};
  try {
    let response = await (await fetch(`${baseUrl}/inspections/${formId}`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    })).json();

    response.data.require_swap = Boolean(response.data.require_swap);
    response.data.one_way_swap = Boolean(response.data.one_way_swap);
    response.data.inspection_pass = Boolean(response.data.inspection_pass);

    form = response.data;
    cacheResponse(`getFormForMachine:${formId}`, form);
  } catch (error) {
    form = await retreiveCachedResponse(`getFormForMachine:${formId}`);
  }

  return form;
}

export async function getFormForTool(formId) {
  let token = await getToken();
  let form = {};
  try {
    let response = await (await fetch(`${baseUrl}/inspections/${formId}`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    })).json();

    response.data.require_swap = Boolean(response.data.require_swap);
    response.data.one_way_swap = Boolean(response.data.one_way_swap);
    response.data.inspection_pass = Boolean(response.data.inspection_pass);

    form = response.data;
    cacheResponse(`getFormForTool:${formId}`, form);
  } catch (error) {
    form = await retreiveCachedResponse(`getFormForTool:${formId}`);
  }

  return form;
}

export async function swapMachineStore(machineId, storeId, toolId) {
  let token = await getToken();
  let url = '';
  if (machineId !== null) {
    url = `${baseUrl}/machines/${machineId}/store/${storeId}`
  }else if (toolId !== null){
    url = `${baseUrl}/tools/${toolId}/store/${storeId}`
  }

  let response = await (await fetch(
    url,
    {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`
      }
    }
  )).json();

  return response;
}

export async function getMachine(machineId) {
  let token = await getToken();
  let data = {};
  try {
    const response = await (await fetch(
      `${baseUrl}/machines/machine_id/${machineId}`,
      {
        headers: { Authorization: `Bearer ${token}` }
      }
    )).json();
    data = response.data;
    cacheResponse(`getMachine:${machineId}`, data);
  } catch (err) {
    data = await retreiveCachedResponse(`getMachine:${machineId}`);
  }
  return data;
}

export async function getTool(toolId) {
  let token = await getToken();
  let data = {};
  try {
    const response = await (await fetch(
      `${baseUrl}/tools/tool_id/${toolId}`,
      {
        headers: { Authorization: `Bearer ${token}` }
      }
    )).json();
    data = response.data;
    cacheResponse(`getTool:${toolId}`, data);
  } catch (err) {
    data = await retreiveCachedResponse(`getTool:${toolId}`);
  }
  return data;
}

export async function createMachineInspection({
  inspection_note,
  inspection_pass,
  machine_id,
  require_swap,
  store_id,
  status,
  one_way_swap,
  new_machine_id,
  machine_hours,
  priority,
  machine,
}) {
  let response = {};
  let token = await getToken();
  let { id } = await getUser();
  const label = "MACHINE INSPECTION";
  const title = `${inspection_note} - ${new Date().toString()}`;

  const url = `${baseUrl}/inspection/machine/store`;// common 
  
  const options = {
    method: "POST",
    headers: {
      "Content-Type": "application/json ; charset=utf-8",
      Authorization: `Bearer ${token}`
    },
    body: JSON.stringify({
      user_id: id,
      store_id,
      inspection_note,
      machines: [{
        "id":machine_id,
        "machine_hours":machine_hours,
        "inspection_pass": inspection_pass,
        "new_machine_id":new_machine_id,
        "machine_status" : status,
        "faulty_reason" : machine.faulty_reason,
        "require_swap":require_swap,
        "one_way_swap":one_way_swap,
        "inspection_note": inspection_note,
      }],
      priority
    })
  };
  try {
    response = await fetch(url, options);
  } catch (error) {
    console.error(error);
    cacheResponse("savedForms", { title, url, options, label }, true);
    notify("Failed to post, added to saved forms", "error");
  }

  return response;
}


export async function createToolInspection({
  inspection_note,
  inspection_pass,
  tool_id,
  require_swap,
  store_id,
  status,
  one_way_swap,
  new_tool_id,
  priority,
  tool,
}) {
  let response = {};
  let token = await getToken();
  let { id } = await getUser();
  const label = "TOOL INSPECTION";
  const title = `${inspection_note} - ${new Date().toString()}`;

  const url = `${baseUrl}/inspection/machine/store`; // common 
  
  const options = {
    method: "POST",
    headers: {
      "Content-Type": "application/json ; charset=utf-8",
      Authorization: `Bearer ${token}`
    },
    body: JSON.stringify({
      user_id: id,
      store_id,
      inspection_note,
      tools: [{
        "id":tool_id,
        "inspection_pass": inspection_pass,
        "new_tool_id":new_tool_id,
        "tool_status" : status,
        "faulty_reason" : tool.faulty_reason,
        "require_swap":require_swap,
        "one_way_swap":one_way_swap,
        "inspection_note": inspection_note,
      }],
      priority
    })
  };
  try {
    response = await fetch(url, options);
  } catch (error) {
    console.error(error);
    cacheResponse("savedForms", { title, url, options, label }, true);
    notify("Failed to post, added to saved forms", "error");
  }

  return response;
}

export async function getMachineFromBarcode(barcode) {
  let token = await getToken();
  const { data } = await (await fetch(
    `${baseUrl}/machines/number/${barcode}`,
    {
      headers: { Authorization: `Bearer ${token}` }
    }
  )).json();
  return data;
}



// WEBPACK FOOTER //
// ./src/backend/machines.js